import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const ModalSensitiveData = ({ open, handelClose, sensitiveData }) => {
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    return (
        <Modal
            width={600}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                <div className="text-[22px] font-normal">
                    {t('MyTask.SensitiveData')}
                </div>
            </div>

            <div className="text-xs font-semibold text-gray-PHX pb-2">
                {t('TotalItems', { length: sensitiveData?.length })}
            </div>

            <div className="grid grid-cols-2 overflow-auto max-h-[34vh]">
                {sensitiveData?.map((item, i) => (
                    <div className="col-span-1 box-content my-1 mx-1 flex items-center">
                        <div className="grid grid-cols-4 p-2 items-center">
                            <div className="col-span-1">
                                <svg
                                    width="40"
                                    height="40"
                                    viewBox="0 0 40 40"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        width="40"
                                        height="40"
                                        rx="20"
                                        fill="#FFF7E6"
                                    />
                                    <g clipPath="url(#clip0_7772_395462)">
                                        <path
                                            d="M27.8176 13.5192C27.7853 13.2871 27.6183 13.0962 27.3926 13.0335L20.1581 11.0215C20.0549 10.9928 19.946 10.9928 19.8428 11.0215L12.6083 13.0335C12.3825 13.0962 12.2156 13.287 12.1832 13.5192C12.1413 13.8209 11.184 20.95 13.6393 24.4965C16.0917 28.0388 19.7095 28.9465 19.8623 28.9835C19.9077 28.9945 19.954 28.9999 20.0004 28.9999C20.0468 28.9999 20.0931 28.9944 20.1385 28.9835C20.2914 28.9465 23.9092 28.0388 26.3615 24.4965C28.8168 20.9501 27.8596 13.821 27.8176 13.5192ZM24.6657 17.6812L19.7311 22.6159C19.6163 22.7307 19.4657 22.7882 19.3152 22.7882C19.1647 22.7882 19.0141 22.7308 18.8992 22.6159L15.8482 19.5648C15.7378 19.4545 15.6759 19.3049 15.6759 19.1489C15.6759 18.9929 15.7379 18.8433 15.8482 18.733L16.454 18.1272C16.6837 17.8975 17.0562 17.8975 17.2858 18.1272L19.3152 20.1565L23.2281 16.2435C23.3384 16.1331 23.488 16.0712 23.644 16.0712C23.8 16.0712 23.9497 16.1331 24.0599 16.2435L24.6657 16.8493C24.8955 17.079 24.8955 17.4515 24.6657 17.6812Z"
                                            fill="#FF6E04"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7772_395462">
                                            <rect
                                                width="18"
                                                height="18"
                                                fill="white"
                                                transform="translate(11 11)"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div className="col-span-3 font-semibold ml-1">
                                {lang === 'en'
                                    ? item?.sensitivePersonalDataEn
                                    : item?.sensitivePersonalDataTh || '-'}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </Modal>
    );
};
export default ModalSensitiveData;
